import {
  copyNode,
  deleteNodeById,
  getActionName,
  getAncestorNodes, getNodeByFlag,
  isBaseModule,
  isBelongAssembleNode,
  walkNode
} from '@/components/common/controlBar/controlBarDialog/metaComponent/utils.js'

import controllers from '@/components/controllers.js'
import { findTranslatePlaces, isInMainLanguage } from '@/consts/lanuages.js'

import { isLanguagePackageType } from "@/components/common/controlBar/controlBarDialog/metaComponent/textInput/languagePackage.js";
import {getNodeById} from "@/components/common/controlBar/controlBarDialog/metaComponent/worker.js";
import {setClipStatus} from "@/components/common/controlBar/controlBarDialog/metaComponent/clip.js";
import {portOfWashDataAssembly} from "@/components/common/controlBar/washData.js";
import {isNodeHasLanguagePackage} from "@/mm/utils.js";
import {getType} from "@/store/source.js";


function emptyAssembleNode(data) {
  walkNode(data.content, (walkedNode) => {
    if (isBelongAssembleNode(walkedNode)) {
      if(!walkedNode.excludeEmptyList){

        walkedNode.list = []
      }


      if (location.href.match('editTemplate=true')) {
        walkedNode.data = undefined
        document.body.classList.add('editTemplate')
      }
    }
  })
  return data
}

export function washData(data) {
  data = emptyAssembleNode(data)

  walkNode(data.content, (walkedNode) => {
    portOfWashDataAssembly(walkedNode)

    // if (walkedNode.componentName && !controllers[walkedNode.componentName]) {
    //   deleteNodeById(walkedNode.id, data.content.list)
    // }

    if (walkedNode.data && walkedNode.data.isShow === '1') {
      walkedNode.data.isShow = true
    }
  })
  return data
}

// 是否是非自身节点的祖先混合节点
export function isOtherNodeOfAncestorCombinedNode(node) {
  var res = false
  var ancestorCombinedNode = getAncestorCombinedNode(node)
  if (ancestorCombinedNode && ancestorCombinedNode !== node) {
    res = true
  }
  return res
}

export function getActionsByNode(node) {
  var list = [
    {
      iconClass: 'zuoqiehuan',
      name: 'pre',
      showName: '上一张',
      callback: (node) => {
        node.preFn && node.preFn()
      }
    },
    {
      iconClass: 'youqiehuan',
      name: 'next',
      showName: '下一张',
      callback: (node) => {
        node.nextFn && node.nextFn()
      }
    },
    {
      iconClass: 'shangyi',
      name: 'upMove',
      showName: '上移',
      callback: (node) => {
        const list = mm.store.state.hasList
        mm.utils.assignToList(list, node.id, (obj, parent, index) => {
          const nodeIndex = index
          const targetIndex = index - 1
          if (parent[targetIndex]) {
            ;[parent[nodeIndex], parent[targetIndex]] = [parent[targetIndex], parent[nodeIndex]]
            mm.store.commit('UPDATE_HAS_LIST', list)
            mm.store.commit('UPDATE_RECT')
          }
        })
      }
    },
    {
      iconClass: 'xiayi',
      name: 'downMove',
      showName: '下移',
      callback: (node) => {
        const list = mm.store.state.hasList
        mm.utils.assignToList(list, node.id, (obj, parent, index) => {
          const nodeIndex = index
          const targetIndex = index + 1
          if (parent[targetIndex]) {
            ;[parent[nodeIndex], parent[targetIndex]] = [parent[targetIndex], parent[nodeIndex]]
            mm.store.commit('UPDATE_HAS_LIST', list)
            mm.store.commit('UPDATE_RECT')
          }
        })
      }
    },
    {
      iconClass: 'fuzhi',
      name: 'copy',
      showName: '复制',
      callback: (node) => {
        copyNode(node)
      }
    },
    {
      iconClass: 'jiahao',
      name: 'add',
      showName: '添加',
      isNeedTab: true
    },
    {
      iconClass: 'lajitong',
      name: 'delete',
      showName: '删除',
      callback: (node) => {
        deleteNodeById(node.id)
        mm.store.commit('UPDATE_BODY')
        mm.store.commit('UPDATE_HAS_LIST', mm.store.state.hasList)
        mm.store.commit('UPDATE_RECT')
      }
    },
    {
      iconClass: (() => {
        if (node.id && getNodeById(node.id) && getNodeById(node.id).controllerModule.isShow) {
          return 'xianshi'
        } else {
          return 'yincang'
        }
      })(),
      name: 'isShow',
      showName: (()=>{
        if(node.id && getNodeById(node.id) && getNodeById(node.id).controllerModule.isShow){
          return getNodeById(node.id).controllerModule.isShow ? '隐藏' : '显示'
        }else{
          return '显示'
        }

      })(),
      callback: (node) => {
        getNodeById(node.id).controllerModule.isShow = !getNodeById(node.id).controllerModule.isShow
        getNodeById(node.id).cacheKey = Date.now()
      }
    },
    // {
    //   iconClass: 'yincang',
    //   name: 'isShow',
    //   showName: '隐藏',
    //   callback: (node)=>{
    //     node.controllerModule.isShow = false
    //   }
    // },
    {
      iconClass: 'fanyi',
      name: 'translate',
      showName: '翻译',
      callback: (node) => {
        mm.store.commit('UPDATE_TRANSLATEDIALOG', {
          startNode: node,
          isShow: true
        })
      }
    },
    {
      iconClass: 'bianji-',
      name: 'edit',
      showName: '编辑'
    },
    {
      iconClass: 'shezhi',
      name: 'playSet',
      showName: '播放设置',
      isNeedTab: true
    },
    {
      iconClass: 'shuxingguanli',
      name: 'attribute',
      showName: '属性',
      isNeedTab: true,
      callback: (node) => {
        if (node.componentName === 'banner_inside') {
          handleFixedHeightStyle(node)
        }
      }
    },
    {
      iconClass: 'sheji',
      name: 'design',
      showName: '设计',
      isNeedTab: true
    },
    {
      iconClass: 'huaguo',
      name: 'hover',
      showName: '划过',
      isNeedTab: true
    },
    {
      iconClass: 'xiaoguo',
      name: 'animate',
      showName: '动画',
      isNeedTab: true
    },
    {
      iconClass: 'lianjie',
      name: 'link',
      showName: '链接',
      isNeedTab: true
    },
    {
      iconClass: 'xiangguanli',
      name: 'itemManage',
      showName: '项管理',
      isNeedTab: true
    },
    {
      iconClass: 'zidingyikongjian-HTMLmoren',
      name: 'html',
      showName: 'HTML',
      isNeedTab: true
    },
    {
      iconClass: 'zidingyikongjian-CSSmoren',
      name: 'css',
      showName: 'CSS',
      isNeedTab: true
    },
    {
      iconClass: 'yangshi',
      name: 'style',
      showName: '样式',
      isNeedTab: true
    },
    {
      iconClass: 'a-mianbaoxiekongjian-tongbumoren',
      name: 'page',
      showName: '选择页面',
      isNeedTab: true
    },
    {
      iconClass: 'shuxingguanli',
      name: 'contactTop',
      showName: '属性',
      isNeedTab: true
    },
    {
      iconClass: 'shuxingguanli',
      name: 'contactBottom',
      showName: '属性',
      isNeedTab: true
    },
    {
      iconClass: 'shoucang1',
      name: 'store',
      showName: '收藏',
      callback: (node) => {
        const { foreign_id } = mm.store.state.authInfo
        mm.store.commit('UPDATE_COLLECT_DATA', {
          a_ksh_control_id: (()=>{
            var id
            walkNode({
              list:[
                mm.store.state.list[1]
              ]
            },(walkedNode)=>{
              var type = getType(walkedNode, false)
              if(node._type === type){
                id = walkedNode.id
              }

            })
            return id
          })(), // 控件id
          a_ksh_template_id: foreign_id !== '0' ? foreign_id : undefined, // 当前模板id
          content: mm.utils.extractFields([node])[0]
        })
      }
    },
    {
      iconClass: 'crop-full',
      name: 'clip',
      showName: '裁切',
      callback: (node) => {
        setClipStatus(node)
      }
    },
  ]

  if(node.forceShowEye){
    if(!node.actions.includes('isShow')){
      node.actions.push('isShow')
    }
  }

  if(node.isCustomModule){
    node.controllerModule.translate = true
    if(node.actions && node.actions.length > 0 && !node.actions.includes('translate')){
      node.actions.push('translate')
    }
  }


  var arr = []
  Object.keys(node.controllerModule)
    .filter((item) => {
      if (node.actions) {
        return node.actions
          .map((action) => {
            return getActionName(action)
          })
          .includes(item)
      } else {
        return true
      }
    })
    .forEach((control) => {
      var match = list.find((item) => {
        return item.name === control
      })
      if (match) {
        arr.push(match)
      }
    })
  const { authInfo } = mm.store.state


  arr = arr.filter((item) => {
    if (item.name === 'translate') {
      if (isInMainLanguage() && authInfo?.type === '') {
        return true
      } else {
        return false
      }
    } else if (item.name === 'add') {
      if (authInfo?.type === 'template') {
        return true
      } else {
        return false
      }
    } else {
      return true
    }
  })

  arr = arr.filter((item) => {
    if (item.name === 'translate') {
      var res = true

      if(isNodeHasLanguagePackage(node)){
        res = false
      }

      return res
    } else {
      return true
    }
  })

  arr = arr.filter((item) => {
    if (item.name === 'isShow') {
      if(node.forceShowEye){
        return true
      }else{
        if (mm.store.state.authInfo.type === '') {
          return true
        } else {
          return false
        }
      }
    } else {
      return true
    }
  })

  // 如果节点是组合节点，则不显示收藏
  var ancestorCombinedNode = getAncestorCombinedNode(node)
  if (
    isOtherNodeOfAncestorCombinedNode(node) &&
    ancestorCombinedNode &&
    ancestorCombinedNode.componentName !== 'banner'
  ) {
    arr = arr.filter((item) => {
      if (item.name === 'store') {
        return false
      } else {
        return true
      }
    })
  }

  //头部、底部、内容区,这三部分区域,每部分至少有一个模块,如果区域中只剩下一个模块,此模块不能删除
  if (isBaseModule(node)) {
    arr = arr.filter((item) => {
      return item.name !== 'delete'
    })
  }

  return arr
}

export function getTabActionsByNode(node) {
  const actions = getActionsByNode(node)
  return actions.filter((action) => {
    return action.isNeedTab === true && action.name !== 'add'
  })
}

function is_editor(str) {
  let div = document.createElement('div')
  div.innerHTML = str
  var res = false
  div.childNodes.forEach((node) => {
    if (node.nodeType === 1) {
      res = true
    }
  })
  return res
}

export function getTranslateRequestData(node) {
  var requestData = []
  // 找出所有的文本
  walkNode(node, (walkedNode) => {
    if(walkedNode.data && walkedNode.data.isShow){
      var translatePlaces = findTranslatePlaces(walkedNode)
      console.log('translatePlaces--', translatePlaces)
      translatePlaces.forEach((translatePlace) => {
        if (translatePlace.type === 'edit') {
          requestData.push({
            type: 'edit',
            nodeId: walkedNode.id,
            text: translatePlace.value
          })
        } else if (translatePlace.type === 'metaComponent') {
          requestData.push({
            type: 'metaComponent',
            nodeId: walkedNode.id,
            customName: translatePlace.customName,
            metaComponentParent: translatePlace.metaComponentParent,
            text: translatePlace.value
          })
        } else if (translatePlace.type === 'banner_item') {
          requestData.push({
            type: 'banner_item',
            nodeId: walkedNode.id,
            key: translatePlace.key,
            text: translatePlace.value
          })
        }
      })
    }

  })

  var res = requestData.map((item) => {
    return {
      ...item,
      text: item.text,
      is_editor: (() => {
        if (is_editor(item.text)) {
          return 1
        } else {
          return 2
        }
      })()
    }
  })

  return res
}

function translateByLanguage(node, language) {
  return new Promise((resolve, reject) => {
    const { hasList } = mm.store.state
    let data = getTranslateRequestData(node)
    let mobileLogo = undefined
    if (node?.flag === 'pc-logo') {
      mobileLogo = getNodeByFlag(hasList[0],'mobile-logo')
      const logoData = getTranslateRequestData(mobileLogo)
      data = [...data, ...logoData]
    }
    mm.http({
      url: '/api/batchTranslate',
      method: 'post',
      data: {
        translate_lang_ids: [language.value],
        data
      }
    }).then(async ({ data, code }) => {
      if (code === 200) {
        if (mm.store.state.translateDialog.result) {
          mm.store.state.translateDialog.result.push(data)
          return resolve(data)
        }
        walkNode(node, (walkedNode) => {
          data.translate.forEach((item) => {
            if (item.nodeId === walkedNode.id) {
              updateTranslateRes({
                node: walkedNode,
                languageId: item.translate_lang_id,
                type: item.type,
                value: item.text,
                metaComponentParent: item.metaComponentParent,
                customName: item.customName,
                key: item.key
              })
            }
          })
        })
        if(node?.flag === 'pc-logo') {
          walkNode(mobileLogo, (walkedNode) => {
            data.translate.forEach((item) => {
              if (item.nodeId === walkedNode.id) {
                updateTranslateRes({
                  node: walkedNode,
                  languageId: item.translate_lang_id,
                  type: item.type,
                  value: item.text,
                  metaComponentParent: item.metaComponentParent,
                  customName: item.customName,
                  key: item.key
                })
              }
            })
          })
        }
        resolve(data)
      } else {
        reject({ data, code })
      }
    })
  })
}

export function updateTranslateRes({
                                     node,
                                     languageId,
                                     type,
                                     value,
                                     metaComponentParent,
                                     customName,
                                     key
                                   }) {
  if (!node.translateRes) {
    node.translateRes = {}
  }
  if (!node.translateRes[languageId]) {
    node.translateRes[languageId] = {
      _temp: 1
    }
  }

  if (type === 'edit') {
    if (!isLanguagePackageType(value)) {
      node.translateRes[languageId]['edit'] = value

      if (node.id) {
        bubbleDescribeNoticeWithInSelf(node, (noticeNode) => {
          noticeNode.onTranslateResChange && noticeNode.onTranslateResChange(node)
        })
      }
    }
  } else if (type === 'metaComponent') {
    if (!node.translateRes[languageId][metaComponentParent]) {
      node.translateRes[languageId][metaComponentParent] = {
        _temp: 1
      }
    }
    if (!isLanguagePackageType(value)) {
      node.translateRes[languageId][metaComponentParent][customName] = value

      if (node.id) {
        bubbleDescribeNoticeWithInSelf(node, (noticeNode) => {
          noticeNode.onTranslateResChange && noticeNode.onTranslateResChange(node)
        })
      }
    }
  } else if (type === 'banner_item') {
    if (!node.translateRes[languageId]) {
      node.translateRes[languageId] = {
        _temp: 1
      }
    }

    if (!isLanguagePackageType(value)) {
      if (!node.translateRes[languageId].imgAttr) {
        node.translateRes[languageId].imgAttr = {}
      }
      node.translateRes[languageId].imgAttr[key] = value

      if (node.id) {
        bubbleDescribeNoticeWithInSelf(node, (noticeNode) => {
          noticeNode.onTranslateResChange && noticeNode.onTranslateResChange(node)
        })
      }
    }
  }
}

export function batchTranslate(node, languages, singleTranslateCallBack, doneCallback) {
  var language = languages.find((language) => {
    return language.translateStatus === 'waiting'
  })
  if (language) {
    language.translateStatus = 'translating'
    translateByLanguage(node, language)
      .then((data) => {
        language.translateStatus = 'success'
        singleTranslateCallBack(data)
        batchTranslate(node, languages, singleTranslateCallBack, doneCallback)
      })
      .catch(({ data, code }) => {
        // 费用不足，停止翻译
        if (code === 50001) {
          doneCallback({ data, code })
        }
        // 翻译失败，但是继续翻译
        else if (code === 500) {
          language.translateStatus = 'fail'
          batchTranslate(node, languages, singleTranslateCallBack, doneCallback)
        }
      })
  } else {
    doneCallback({
      data: undefined,
      code: 'over'
    })
  }
}

// 处理固定高度样式
function handleFixedHeightStyle(node) {
  const match = getMetaComponentItemByTitle(node, 'attribute', '自定义高度')
  const match2 = getMetaComponentItemByTitle(node, 'attribute', '高度')
  match2.isHide = !match.value['radio-value']
}

export function bubbleDescribeNoticeWithInSelf(node, callback) {
  var ancestorNodes = getAncestorNodes(node)
  for (var noticeNode of [...ancestorNodes, node]) {
    callback && callback(noticeNode)
  }
}

export function getBgImageSize(bgUrl) {
  return new Promise((resolve, reject) => {
    // 2. 提取纯URL（兼容 url("xxx")、url('xxx')、url(xxx) 三种写法）
    const url = bgUrl.match(/url\(["']?(.+?)["']?\)/)[1]
    if (!url) {
      reject(new Error('无法解析背景图URL'))
      return
    }

    // 3. 创建临时Image对象加载图片
    const img = new Image()
    // 解决跨域图片无法获取尺寸的问题（需服务器配置CORS）
    img.crossOrigin = 'anonymous'

    // 图片加载完成后获取尺寸
    img.onload = () => {
      resolve({
        width: img.width,
        height: img.height,
        ratio: img.width / img.height // 可选：返回宽高比
      })
    }

    // 图片加载失败
    img.onerror = () => {
      reject(new Error('背景图加载失败（可能跨域/URL错误）'))
    }

    // 4. 触发图片加载
    img.src = url
  })
}
